import React from 'react';
import { Fab, styled, Zoom, ZoomProps } from '@mui/material';

import { SizingMultiplier } from '@ocx/ui';

const StyledFab = styled(Fab)(({ theme }) => ({
  margin: theme.spacing(SizingMultiplier.sm),
}));

type ControlButtonProps = {
  onClick?(): void;
  icon: NonNullable<React.ReactNode>;
  zoomProps?: Omit<ZoomProps, 'children'>;
  disabled?: boolean;
};

export const ControlButton = (props: ControlButtonProps) => {
  const { icon, onClick, zoomProps, disabled } = props;
  return (
    <Zoom in {...zoomProps}>
      <StyledFab onClick={onClick} disabled={disabled}>
        {icon}
      </StyledFab>
    </Zoom>
  );
};
